import styled from 'styled-components'
import { theme } from 'styles/mui-config'

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  direction: ltr;
  border: solid 1px transparent;
  box-shadow: 0 0 2px ${theme.palette.primary.main};
  cursor: ${props => props.isWeb || props.refillable ? 'pointer' : 'default'};
  border-radius: 5px;
  color: ${theme.palette.primary.main};
  width: 100%;
  height: 200px;
  overflow:hidden;
`;

export const DeleteDiv = styled.div`
  width: 25px;
  height: 25px;
  background-color: white;
  color: ${theme.palette.primary.main};
  position: absolute;
  bottom: 0px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px ;
  border-top-right-radius: 10px;
  box-shadow: 0 0 5px gray;
  &:hover{
    box-shadow: 0 0 8px gray;
  }
`;
